<template>
   <div id="app">
   <vue-headful
      title="icrewsystems | Testing Server"
      description="This is a testing server, running proudly using GreenEnergy in the United Kingdom for ICREWSYSTEMS SOFTWARE ENGINEERING LLP. All of our projects will be staged for testing in this server."
      keywords=""
      image=""
      lang=""
      ogLocale=""
      url=""
    />

<div class="bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 shadow-2xl" v-show='toggle'>
  <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between flex-wrap">
      <div class="w-0 flex-1 flex items-center">
        <span class="flex p-2 rounded-lg bg-indigo-800">
          <!-- Heroicon name: speakerphone -->
          <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
          </svg>
        </span>
        <p class="ml-3 font-medium text-white truncate">
          <span class="md:hidden">
            We're hiring!
          </span>
          <span class="hidden md:inline">
            Good news, we're hiring developers. Apply now!
          </span>
        </p>
      </div>
      <div class="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
        <a href="https://icrewsystems.com/en/careers" target="_blank" class="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-indigo-600 bg-white hover:bg-indigo-50">
          Learn more
        </a>
      </div>
      <div
      class="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
        <button  @click='toggle = !toggle' type="button" class="-mr-1 flex p-2 rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2">
          <span class="sr-only">Dismiss</span>
          <!-- Heroicon name: x -->
          <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

      <div class="bg-gradient-to-r from-blue-800 to-blue-900 px-4 py-4">
         <div
            class="md:max-w-6xl md:mx-auto md:flex md:items-center md:justify-between"
            x-data="{ open: false }"
            x-cloak
            >
            <div class="flex justify-between items-center">
               <a href="#" class="inline-block py-2 text-white text-xl font-bold">
                <img class="h-8" src="https://cdn.discordapp.com/attachments/530789778912837640/780297958734299167/icrewsystems_logo_white_highres.png">
               </a>
               <div
                  class="inline-block cursor-pointer md:hidden"
                  x-on:click="open=true"
                  >
                  <div class="bg-gray-400 w-8 mb-2" style="height: 2px;"></div>
                  <div class="bg-gray-400 w-8 mb-2" style="height: 2px;"></div>
                  <div class="bg-gray-400 w-8" style="height: 2px;"></div>
               </div>
            </div>
            <div x-show="open" x-on:click.away="open = false">
               <a href="#" class="block py-2 text-gray-100">Main Site</a>
               <a href="#" class="block py-2 text-indigo-300 hover:text-gray-100">Services</a>
               <a href="#" class="block py-2 text-indigo-300 hover:text-gray-100">Blog</a>
               <div class="flex items-center justify-between pt-4">
                  <a href="https://icrewsystems.com/portal" class="w-1/2 inline-block py-2 px-4 text-white bg-red-500 hover:bg-red-600 rounded-lg text-center font-bold">
                  Portal
                  </a>
               </div>
            </div>
            <div>
               <div class="hidden md:block">
                  <a
                     href="https://icrewsystems.com?ref=https://testing.icrewsystems.com" target="_blank"
                     class="inline-block py-1 md:py-4 text-gray-500 hover:text-gray-100 mr-6"
                     >Main Site</a
                     >
                  <a
                     href="https://icrewsystems.com/portal/index.php/tickets" target="_blank"
                     class="inline-block py-1 md:py-4 text-gray-500 hover:text-gray-100 mr-6"
                     >Support</a
                     >
                  <a
                     href="https://icrewsystems.com/blog" target="_blank"
                     class="inline-block py-1 md:py-4 text-gray-500 hover:text-gray-100"
                     >Blog</a
                     >
               </div>
            </div>
            <div class="hidden md:block">
               <a
                  href="https://icrewsystems.com/portal"
                  class="inline-block py-2 px-4 text-gray-700 bg-white hover:bg-gray-100 rounded-lg"
                  >Portal</a
                  >
            </div>
         </div>
      </div>

      <body-content></body-content>
      <footer-content></footer-content>
   </div>
</template>
<script>
   export default {
     name: 'app',
     data () {
      return {
        toggle: true
      }
    },
     components: {}
   }
</script>
<style src="./assets/css/style.css"></style>
